import resume from '../assets/pdf/Software Developer Devesh Verma.pdf'

export const headerData = {
    name: 'Devesh Verma',
    title: "Full-Stack Developer",
    desciption:"Passionate Full-Stack Web Developer, excelling in JavaScript, React, Node.js, and MongoDB, creating visually appealing and highly functional websites.",
    image: 'https://i.ibb.co/Y4qVSt5x/profile-pic-1-2.jpg',
    resumePdf: resume
    
}
